import kfetch from '@kareo/kfetch';
import getSessionId from '../utils/sessionId';

export const BAD_PARAMS_ERROR =
  'isEnabled requires a param that is either a string or array of strings';

export const DATA_HASNT_LOADED_ERROR = 'featureMap doesnt exist';

class FeatureToggles {
  constructor() {
    this.instance = null;
    this.fetchPromise = null;
    this.featureMap = null;
  }

  async getFeatures() {
    if (!this.fetchPromise) {
      const sessionId = getSessionId();

      this.fetchPromise = kfetch(
        `/common-ui/api/Practice/features?sessionId=${encodeURIComponent(
          sessionId,
        )}`,
      ).then(featureResponse => {
        if (featureResponse) {
          this.featureMap = {};
          featureResponse.forEach(f => {
            this.featureMap[f] = true;
          });
        }
        return featureResponse;
      });
    }
    return this.fetchPromise;
  }

  /**
   *
   * @param {string | string[]} featureNames
   * @returns boolean | boolean[]
   */
  _isEnabled(featureNames) {
    if (
      !featureNames ||
      (Array.isArray(featureNames) && featureNames.length === 0)
    ) {
      throw new TypeError(BAD_PARAMS_ERROR);
    }

    if (!!this.featureMap) {
      if (!Array.isArray(featureNames)) {
        featureNames = [featureNames];
      }

      let featuresArr = featureNames.map(name =>
        this.featureMap.hasOwnProperty(name),
      );

      return !!featuresArr && featuresArr.length === 1
        ? featuresArr[0]
        : featuresArr;
    } else {
      throw new Error(DATA_HASNT_LOADED_ERROR);
    }
  }

  /**
   * check if feature toggles are enabled
   * @param {String | Array<String>} featureNames
   * @returns {Promise<Boolean | Array<Boolean>>}
   */
  async isEnabled(featureNames) {
    if (!this.featureMap) {
      await this.getFeatures();
    }

    return this._isEnabled(featureNames);
  }

  static get() {
    if (!this.instance) {
      this.instance = new FeatureToggles();
    }

    return this.instance;
  }

  /**
   * This should be used inside of tests in order to reset feature sets
   */
  clearCache() {
    if (this.featureMap) {
      this.featureMap = null;
    }
    if (this.fetchPromise) {
      this.fetchPromise = null;
    }
  }
}

// Export a single instance of the FeatureToggles class
const featureToggles = FeatureToggles.get();

export default featureToggles;
